"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionValidator = void 0;
const date_fns_1 = require("date-fns");
class PromotionValidator {
    validateDateTime(startDateTime, endDateTime) {
        return date_fns_1.isWithinInterval(new Date, {
            start: date_fns_1.parseISO(startDateTime),
            end: date_fns_1.parseISO(endDateTime)
        });
    }
    validateCriteriaGroup(value, criteriaGroup) {
        if (!criteriaGroup)
            return true;
        if (criteriaGroup.relationTypeInGroup === 'OR') {
            let result = false;
            for (const criteria of criteriaGroup.criteria) {
                if (this.validateCriteria(value, criteria)) {
                    return result = true;
                }
            }
            return result;
        }
        if (criteriaGroup.relationTypeInGroup === 'AND') {
            const result = [];
            for (const criteria of criteriaGroup.criteria) {
                result.push(this.validateCriteria(value, criteria));
            }
            return result.every(Boolean);
        }
        return false;
    }
    validateCriteria(value, criteria) {
        switch (criteria.criteriaOperator) {
            case "=": {
                if (typeof value === 'string') {
                    return value.toUpperCase() === criteria.criteriaValue.toUpperCase();
                }
                else if (typeof value === 'number') {
                    return value === Number(criteria.criteriaValue);
                }
            }
            case "!=": {
                if (typeof value === 'string') {
                    return value.toUpperCase() !== criteria.criteriaValue.toUpperCase();
                }
                else if (typeof value === 'number') {
                    return value !== Number(criteria.criteriaValue);
                }
            }
            case "<=": {
                if (typeof value === 'number') {
                    return value <= Number(criteria.criteriaValue);
                }
            }
            case ">=": {
                if (typeof value === 'number') {
                    return value >= Number(criteria.criteriaValue);
                }
            }
            default:
                return false;
        }
    }
}
exports.PromotionValidator = PromotionValidator;
//# sourceMappingURL=promotionValidator.js.map